import React, { Component, Fragment } from 'react';
import { Col } from "reactstrap";
import { inject, observer } from 'mobx-react';
import BootstrapTable from 'react-bootstrap-table-next';
import { E_CONDICAO } from '../stores/Enum';
import { IconeDelete } from '../../comum/components/Icones';

@inject("store")
@observer
export default class ListaServicos extends Component {
    constructor(props) {
        super(props);

        this.dataStore = this.props.dataStore;
        this.modalStore = this.props.store.modalStoreCustom;
    }

    
    renderBotoesServicos = (cell, row, rowIndex, colIndex) => {
        return (
            <div>
                {row.Basico.toUpperCase() == E_CONDICAO.N_a && 
                    <IconeDelete tamanho="lg" className="m-0" onClick={() => this.dataStore.removeServicoPorCodigo(row.Codigo)}/>
                }
            </div>
        )        
    }

    colunas = [
        {
            dataField: "Servico",
            text: "Serviço",
            headerAlign: (column, colIndex) => 'left',
            align: () => { return "left" },
        }, 
        {
            dataField: "Qtd",
            text: "Quantidade",
            headerAlign: (column, colIndex) => 'center',
            align: () => { return "center" },
            classes: "px-0",
            headerClasses: "px-0",
        },
        {
            dataField: 'acoes',
            text: 'Excluir',
            isDummyField: true,
            formatter: this.renderBotoesServicos,
            editable: false,
            headerAlign: (column, colIndex) => 'center',
            align: () => { return "center" },
        }
    ];

    rowStyle = (row, rowIndex) => {
        const style = {};
        if (row.Basico.toUpperCase() != E_CONDICAO.Sim) {
            style.backgroundColor = '#C3C3C3';
        } else {
            style.backgroundColor = '#FFF';
        }
        style.borderBottom = '1px solid #dee2e6';
    
        return style;
    }

    render() {
        const qtdRegistros = this.dataStore.servicosAgrupados.length;
        const mostraScroll = qtdRegistros > 5; // limitando a qtde de registro para ajustar o height da table e aparecer o scroll

        return (
            <Fragment>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="mt-3">
                    <Fragment>
                        <div id="tableHeaderFixed" className={`${mostraScroll ? 'tabela-overflow-paginated' : ''}  border-top`}
                            style={ { height: mostraScroll ? '250px' : 'auto'}}
                        >
                            <BootstrapTable
                                bootstrap4
                                striped
                                condensed
                                hover
                                bordered={false}
                                classes="tabela tabela-layout mb-0 border-bottom border-right border-left"
                                keyField='Codigo'
                                data={[...this.dataStore.servicosAgrupados]}
                                columns={[...this.colunas]}
                                rowStyle={ this.rowStyle }
                                noDataIndication="Nenhum serviço encontrado com esses filtros"
                            />
                        </div>                            
                    </Fragment>
                </Col>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/ListaServicos.js